import React, { useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import InvoiceForm from "./InvoiceForm";

export default function InvoiceDialog({ shipmentId, label, testid, onSaved }) {
  const [open, setOpen] = useState(false);
  const [sh, setSh] = useState(null);

  const onOpenChange = async (v) => {
    setOpen(v);
    if (!v) return;
    setSh(null);
    try { const { data } = await api.get(`/shipments/${shipmentId}`); setSh(data); }
    catch (e) { toast.error(formatError(e)); setOpen(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid={testid} size="sm" className="h-7 bg-blue-600 hover:bg-blue-500">{label}</Button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-800 text-slate-100 max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-display text-2xl">{sh?.billing_info?.invoice_number || "New invoice"}</DialogTitle></DialogHeader>
        {sh ? <InvoiceForm sh={sh} onSaved={() => { setOpen(false); onSaved(); }} /> : <div className="text-slate-400 text-sm">Loading…</div>}
      </DialogContent>
    </Dialog>
  );
}
